import { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { MetaPredictions } from '../../../../../api/services/mediaPlanning/getMetaPredictionsValidity';
import MetaPredictionsTable from '../../Plan/MetaPredictionsTable/MetaPredictionsTable';

export interface PricingAccordionProps {
  pricingData?: MetaPredictions;
  isLoading: boolean | undefined;
  isValidityCheck: boolean;
}

function PricingAccordions({
  pricingData,
  isLoading,
  isValidityCheck,
}: PricingAccordionProps) {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  useEffect(() => {
    if (pricingData && pricingData.data.length > 0) {
      setExpandedIndex(0);
    }
  }, [pricingData]);

  const handleChange =
    (index: number) => (event: any, isExpanded: boolean | null) => {
      setExpandedIndex(isExpanded ? index : null);
    };

  if (isLoading || !isValidityCheck || !pricingData) return null;

  return (
    <>
      {pricingData.data.map((country, index) => (
        <Accordion
          key={country.value?.country}
          expanded={expandedIndex === index}
          onChange={handleChange(index)}
          sx={index !== 0 ? { borderTop: '1px solid #CCCCCC' } : {}}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              height: '56px',
              background: 'white',
              '.MuiAccordionSummary-content': {
                height: 'unset',
                pl: 0,
              },
            }}
          >
            <Typography>{country.value?.country}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {country.value?.message && (
              <Typography sx={{ fontSize: '12px', color: '#F00F00' }}>
                {country.value?.message}
              </Typography>
            )}
            {country.value && <MetaPredictionsTable pricingData={country} />}
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
}

export default PricingAccordions;
